import { CLASSTING_FULL_AUTH_URL, CLASSTING_AI_INTRO_WEB } from '@/config';

import store from '@/store';
import { includes } from 'lodash';

const needAuth = auth => (auth === true);
const needRole = role => (role === true);

function beforeEachRoutes(router) {
  router.beforeEach((to, from, next) => {
    const auth = to.meta.requiresAuth;
    const role = to.meta.requiresRole;

    if (
      to.name !== 'user-licence'
      && to.name !== 'auth.oauthCallback'
      && to.name !== 'auth.mobileCallback'
    ) {
      window.location.href = `${CLASSTING_AI_INTRO_WEB}/home`;
    }

    if (from.query.parent_ids) {
      /* eslint-disable no-param-reassign */
      to.query.parent_ids = from.query.parent_ids;
      /* eslint-enable */
    }

    store.dispatch('checkUserToken')
      .then(() => {
        if (needRole(role)) {
          const user = store.getters.currentUser;
          const userCountry = store.getters.currentUserCountryCode;
          const supportCountries = store.getters.getSupportCountries;
          if (!includes(supportCountries, userCountry)) {
            next({
              name: 'errors.notSupportCountry',
            });
          } else if (user.role === 'teacher') {
            next({
              name: 'errors.unAuthorized',
            });
          } else {
            next();
          }
        } else {
          next();
        }
      })
      .catch(() => {
        if (needAuth(auth)) {
          if (to.query && to.query.source === 'classting') {
            next({
              path: `/mobile_callback/classting?continue_url=${encodeURIComponent(to.fullPath)}`,
              replace: true,
            });
          } else {
            sessionStorage.setItem('continue_url', to.fullPath);
            window.location.href = CLASSTING_FULL_AUTH_URL;
          }
        } else {
          next();
        }
      });
  });
}

export default beforeEachRoutes;



// WEBPACK FOOTER //
// ./src/router/beforeEachRoutes.js